<template>
  <div>
    <div class="modal-header">
      <h3
        class="modal-title"
      >Сессия ( Начало : {{currentXReport.startDate }} - Конец : {{ currentXReport.endDate }})</h3>
      <button type="button" @click="close" class="close" data-dismiss="modal" aria-label="Close">
        <span aria-hidden="true">×</span>
      </button>
    </div>

    <div class="modal-body">
      <div class="row">
        <div class="col-sm-12">
          <div class="modal-body box-z-report">
            <template v-if="currentXReport.totalWithoutDiscount != 0">
              <table class="table table-striped table-bordered">
                <tbody>
                  <tr v-for="(key,index) in currentXReport.payments" :key="index">
                    <td v-if="index==='QARZGA' && key > 0">В Долг</td>
                    <td v-if="index==='HOMIYLIK' && key > 0">Спонсорство</td>
                    <td v-if="index==='CERTIFICATE' && key > 0">Сертификат</td>
                    <td v-if="index==='CASH' && key > 0">Наличные деньги</td>
                    <td v-if="index==='BANK_CARD' && key > 0">Банковская карта</td>
                    <td v-if="index==='BANK_TRANSFER' && key > 0">Перечисления</td>

                    <td v-if="index !== 'PAID' && key > 0">
                      <span class="display_currency" data-currency_symbol="true">
                        {{ key | currency({
                        symbol: userDepCurrencyName, fractionCount: 2, symbolPosition: 'back',
                        thousandsSeparator: ' '
                        }) }}
                      </span>
                    </td>
                  </tr>
                  <tr class="success">
                    <th>Общая сумма</th>
                    <td>
                      <b>
                        <span class="display_currency" data-currency_symbol="true">
                          {{ currentXReport.totalWithoutDiscount | currency({
                          symbol: userDepCurrencyName, fractionCount: 2, symbolPosition: 'back',
                          thousandsSeparator: ' '
                          }) }}
                        </span>
                      </b>
                    </td>
                  </tr>
<!--                  <tr class="success">-->
<!--                    <th>Общая сумма со скидкой</th>-->
<!--                    <td>-->
<!--                      <b>-->
<!--                        <span class="display_currency" data-currency_symbol="true">-->
<!--                          {{ currentXReport.totalWithDiscount | currency({-->
<!--                          symbol: userDepCurrencyName, fractionCount: 2, symbolPosition: 'back',-->
<!--                          thousandsSeparator: ' '-->
<!--                          }) }}-->
<!--                        </span>-->
<!--                      </b>-->
<!--                    </td>-->
<!--                  </tr>-->
                  <tr class="success">
                    <th>Общая сумма возврата</th>
                    <td>
                      <b>
                        <span class="display_currency" data-currency_symbol="true">
                          {{ currentXReport.totalRefundAmount | currency({
                          symbol: userDepCurrencyName, fractionCount: 2, symbolPosition: 'back',
                          thousandsSeparator: ' '
                          }) }}
                        </span>
                      </b>
                    </td>
                  </tr>
                  <tr class="success">
                    <th>Общая сумма касса</th>
                    <td>
                      <b>
                        <span class="display_currency" data-currency_symbol="true">
                          {{currentXReport.totalWithDiscount- currentXReport.totalRefundAmount | currency({
                          symbol: userDepCurrencyName, fractionCount: 2, symbolPosition: 'back',
                          thousandsSeparator: ' '
                          }) }}
                        </span>
                      </b>
                    </td>
                  </tr>
<!--                  <tr class="success">-->
<!--                    <th>Общая сумма скидки</th>-->
<!--                    <td>-->
<!--                      <b>-->
<!--                        <span class="display_currency" data-currency_symbol="true">-->
<!--                          {{currentXReport.totalDiscount | currency({-->
<!--                          symbol: userDepCurrencyName, fractionCount: 2, symbolPosition: 'back',-->
<!--                          thousandsSeparator: ' '-->
<!--                          }) }}-->
<!--                        </span>-->
<!--                      </b>-->
<!--                    </td>-->
<!--                  </tr>-->
                  <tr class="success">
                    <th>Общая кол-во товаров</th>
                    <td>
                      <b>
                        <span
                          class="display_currency"
                          data-currency_symbol="true"
                        >{{ currentXReport.count }}</span>
                      </b>
                    </td>
                  </tr>
                  <tr class="success">
                    <th>Общая кол-во возврат товаров</th>
                    <td>
                      <b>
                        <span
                          class="display_currency"
                          data-currency_symbol="true"
                        >{{ currentXReport.refundCount }}</span>
                      </b>
                    </td>
                  </tr>
                </tbody>
              </table>
            </template>
            <template v-else>
              <b-alert variant="info" show>Продажи еще не сделаны</b-alert>
            </template>
          </div>
        </div>
        <div class="col-sm-12">
          <b>Кассир:</b>
          {{ currentXReport.cashierFullName }}
          <br />
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-primary" @click="close" data-dismiss="modal">Закрыть</button>
      <!--				<button type="submit" class="btn btn-primary" @click="close">Close Register</button>-->
    </div>
  </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
import { TokenService } from "../../../../../services/storage.service";

export default {
  name: "XReport",

  async created() {
    await this.getCurrentXReport(localStorage.getItem('dep_id'));
  },

  computed: {
    ...mapState(["userDepCurrencyName"]),
    ...mapState("zetReport", ["currentXReport"])
  },

  methods: {
    ...mapActions("zetReport", ["getCurrentXReport"]),
    close() {
      this.$emit("close");
    }
  }
};
</script>

<style scoped>
.box-z-report {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  border-bottom-right-radius: 3px;
  border-bottom-left-radius: 3px;
  padding: 10px;
}
</style>
